import React from 'react';

import './LoadingScreen.css';

// LoadingScreen component for initial game loading
export const LoadingScreen: React.FC = () => {
  return (
    <div className='App'>
      <div className='loading-screen'>
        <h1>FactoryGPT</h1>
        <div className='loading-poster-placeholder' aria-hidden='true'>
          <div className='loading-poster-skeleton' />
        </div>
        <div className='loading-message'>
          <p>Loading game...</p>
          <div className='loading-spinner'>🤖</div>
        </div>
        <div className='loading-details'>
          <p>Initializing world generation...</p>
          <p>Setting up game systems...</p>
          <p>Preparing automation framework...</p>
        </div>
      </div>
    </div>
  );
};
